import KeyStrokeCounterViewState from '../store/schema/KeyStrokeCounterViewState';

export default function createKeyStrokeCounterViewState(): KeyStrokeCounterViewState {
    return {
        keyStrokeCount: 0,
    };
}
